import { Component, Input } from '@angular/core';
import AppValues from 'src/app/common/app.values';
import { MapValues } from 'src/app/components/map/map.values';
import { MapStatisticsIconsLookup, MapStatisticsTabsLookup } from 'src/app/components/map/types/custom.types';
import { OverallStatistics } from 'src/app/interfaces/map.interface';
import { MapFlags } from 'src/app/models/map-flags.model';

@Component({
  selector: 'app-users-total',
  templateUrl: './users-total.component.html',
  styleUrls: ['./users-total.component.scss'],
})
export class UsersTotalComponent {
  @Input({ required: true }) public statistics: OverallStatistics;
  @Input({ required: true }) public flags: MapFlags;

  public iconPresets: MapStatisticsTabsLookup = MapValues.mapStatisticsTabsLookup;
  public formatDate: string = AppValues.DATE_FORMAT_SHORT;

  public infoUpdate = 'updated';

  public mapStatisticsIconsLookup: MapStatisticsIconsLookup = MapValues.mapStatisticsIconsLookup;
}
